import { isAxiosError } from 'axios';
import type { CodedMessage } from './message-keys';

/** What a refused request said, read from the problem-details body assets-api answers with. */
export interface Problem {
  status: number | undefined;
  code: string | undefined;
  detail: string | undefined;
  issues: (CodedMessage & { entityKey: string; field?: string })[];
}

export function readProblem(error: unknown): Problem {
  const data: unknown = isAxiosError(error) ? error.response?.data : undefined;
  const body = typeof data === 'object' && data !== null ? (data as Record<string, unknown>) : {};
  return {
    status: isAxiosError(error) ? error.response?.status : undefined,
    code: typeof body.code === 'string' ? body.code : undefined,
    detail: typeof body.detail === 'string' ? body.detail : undefined,
    issues: Array.isArray(body.issues) ? (body.issues as Problem['issues']) : [],
  };
}
